module.exports = __webpack_public_path__ + "img/cszd.1a7d31cd.png";